import React from "react";
import { useMsal } from "@azure/msal-react";
import "./unauthorizedPage.css";

const UnauthorizedPage = () => {
  const { instance, accounts } = useMsal();
  const userEmail = accounts[0]?.username || "Unknown";

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">🚫</div>
        <h1>Access Denied</h1>
        <p className="unauthorized-message">
          Your account (<strong>{userEmail}</strong>) is not authorized to
          access the RTLS Dashboard.
        </p>
        <p className="unauthorized-instructions">
          If you believe this is an error, please contact Zachary Amdur
          (Zachary.Amdur@Zekelman.com) to request access.
        </p>

        <div className="unauthorized-actions">
          <button onClick={handleLogout} className="logout-btn">
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
